import { type ReactNode, createContext, useContext } from "react";
import { useGetSessionSuspenseQuery } from "../api/routes/session.ts";

interface SessionContext {
    accountId: string;
    displayName: string;
    firstName: string;
}

const SessionContext = createContext<SessionContext | undefined>(undefined);

interface SessionProviderProps {
    children: ReactNode;
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
    const { data: session } = useGetSessionSuspenseQuery();

    return (
        <SessionContext.Provider
            value={{
                accountId: session.accountId,
                displayName: session.userDisplayName,
                firstName: session.firstName
            }}
        >
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => {
    const context = useContext(SessionContext);

    if (!context) {
        throw new Error("useSession must be used within a SessionProvider");
    }

    return context;
};
